import {ENV_BASE_URL} from './EnvironmentConfig';

export enum ENV_TYPES {
  DEV = 'dev',
  INT = 'int',
  LOCAL = 'local',
  PROD = 'prod',
  STAGING = 'staging',
  TRAINING = 'training'
}

export class Environment {
  constructor(code: ENV_TYPES) {
    this.code = code;

    this.base = true;
    this.reqTimeout = 245000;
    this.baseUrl = ENV_BASE_URL[code];
    this.googleMapApiKey = 'AIzaSyCJ76ZpeMJPlKSoFei_qbnEv786U0 - heeY';
  }

  readonly code: ENV_TYPES;
  readonly base?: boolean;
  readonly baseUrl: string;
  readonly reqTimeout: number;
  readonly googleMapApiKey: string;
}
